module.exports = __webpack_public_path__ + "img/bens_patrimonio.5dd5dce1.png";